export const nameReducer = 'features';
